import R from 'app/assets/R'
import { ModulePermissionEnum } from 'app/common/permission-module'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import { BaseLayoutReport } from 'app/components/common/BaseLayoutReport'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { data } from './data'

const HumanResourcesContainer = () => {
  const { t } = useTranslation()

  const { isHavePermissionAndGoBack } = useVerifyPermissionAndRedirect()

  useEffect(() => {
    isHavePermissionAndGoBack(ModulePermissionEnum.HR, R.strings.hr)
  }, [t])

  return (
    <BaseLayoutReport
      data={data}
      titleI18nKey={R.strings.hr}
      modulePermission={ModulePermissionEnum.HR}
    />
  )
}

export default HumanResourcesContainer
